// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1xvwY","filesListContainer":"PosDisputesFiles_filesListContainer__1OQVP","filesButton":"PosDisputesFiles_filesButton__1Bx5k"};